import {ReactComponent as MiniInformationIcon} from "../../../../core/ui/icon/MiniInformation.svg";

import "./_swap-details-modal-detail-row.scss";

import {ReactNode} from "react";
import classNames from "classnames";

import Tooltip from "../../../../component/tooltip/Tooltip";
import TooltipContent from "../../../../component/tooltip/content/TooltipContent";
import Typography from "../../../../component/typography/Typography";

interface SwapDetailsModalDetailRowProps {
  title: string;
  description: ReactNode;
  tooltipContent?: string;
}

function SwapDetailsModalDetailRow({
  title,
  tooltipContent,
  description
}: SwapDetailsModalDetailRowProps) {
  const rowTitle = <Typography textColor={"text-gray"}>{title}</Typography>;

  return (
    <div className={classNames("has-space-between", "swap-details-modal-detail-row")}>
      {tooltipContent ? (
        <Tooltip
          placement={"top"}
          type={"no-underline"}
          customClassName={"swap-details-modal-detail-row__title-tooltip"}
          content={
            <TooltipContent
              customClassName={"swap-details-modal-detail-row__title-tooltip__content"}>
              {tooltipContent}
            </TooltipContent>
          }>
          {rowTitle}

          <MiniInformationIcon />
        </Tooltip>
      ) : (
        rowTitle
      )}

      <Typography fontWeight={"medium"}>{description}</Typography>
    </div>
  );
}

export default SwapDetailsModalDetailRow;
